import { motion } from "framer-motion";
import { Users, Store, Handshake } from "lucide-react";

const STATS = [
  { icon: Users, value: "40+", label: "Installer LOIs", id: "lois" },
  { icon: Store, value: "Merchant", label: "Interest", id: "merchant" },
  { icon: Handshake, value: "UK Pilot", label: "Programme", id: "pilot" },
];

const reveal = {
  hidden: { opacity: 0, y: 32 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: i * 0.12 },
  }),
};

export default function Trade() {
  return (
    <section id="trade" className="bg-[#f7fafc] py-20 sm:py-28 scroll-mt-16" data-testid="trade-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <div>
          <motion.p
            variants={reveal}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-80px" }}
            custom={0}
            className="text-xs font-semibold uppercase tracking-[0.22em] text-slate-500 mb-4"
            data-testid="trade-eyebrow"
          >
            Trade Validation
          </motion.p>
          <motion.h2
            variants={reveal}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-80px" }}
            custom={0}
            className="font-display font-extrabold uppercase leading-[1.05] tracking-tight text-4xl sm:text-5xl text-[#0a1f33]"
          >
            Real Interest
            <br />
            From The Trade
          </motion.h2>
          <motion.span variants={reveal} initial="hidden" whileInView="show" viewport={{ once: true }} custom={0} className="block w-12 h-1 bg-[#1c9ce8] mt-6" />
          <motion.p
            variants={reveal}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-80px" }}
            custom={1}
            className="mt-7 text-slate-600 leading-relaxed max-w-md"
            data-testid="trade-body"
          >
            We've already had 40+ installer LOIs, merchant interest and installers
            signing up for our controlled pilot programme.
          </motion.p>
        </div>

        <div className="grid gap-4">
          {STATS.map((s, i) => (
            <motion.div
              key={s.id}
              variants={reveal}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-60px" }}
              custom={i + 1}
              className="flex items-center gap-5 bg-white border border-slate-200 rounded-2xl px-7 py-6 shadow-[0_4px_24px_rgba(10,31,51,0.05)]"
              data-testid={`trade-stat-${s.id}`}
            >
              <span className="flex items-center justify-center w-12 h-12 rounded-full bg-[#e9f4fc] shrink-0">
                <s.icon className="w-5 h-5 text-[#1c9ce8]" strokeWidth={1.8} />
              </span>
              <div>
                <p className="font-display font-extrabold text-xl text-[#0a1f33] leading-tight">{s.value}</p>
                <p className="text-sm text-slate-500">{s.label}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
